export const customEvents = {
  showToast: 'custom:showToast',
  refreshCustomerBalances: 'custom:refreshCustomerBalances',
  showCartDropdown: 'custom:showCartDropdown',
};

export const authenticatedOnKey = 'authenticatedOn';

export const appTypes = {
  benefit: 'benefit',
  merchants: 'merchants',
};

export const LEGAL_INFORMATION_IDS = {
  termsAndConditions: {
    default: 5,
    savings: 14,
  },
  privacyPolicy: {
    default: 3,
    savings: 15,
  },
  cookies: {
    default: 9,
    savings: 9,
  },
  accessibility: {
    default: 16,
    savings: 16,
  },
} as const;

export type LegalInformationType = keyof typeof LEGAL_INFORMATION_IDS;
